import { RequestsPaginateService } from './requests-paginate.service';

export default angular
  .module('sfMobile.services.requests-paginate', ['sfMobile.services.log'])
  .factory('RequestsPaginate', RequestsPaginateService).name;
